import { Box, Button, Stack, Typography } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { heroGradient } from '../styles';
import { openGeneralContact } from '../contact';

const ContactBand = () => (
    <Box
        dir="rtl"
        sx={{
            borderRadius: '28px',
            p: { xs: 3, md: 5 },
            color: '#ffffff',
            background: heroGradient,
            boxShadow: '0 20px 55px rgba(15, 60, 95, 0.22)'
        }}
    >
        <Stack
            dir="rtl"
            direction={{ xs: 'column', md: 'row' }}
            spacing={2.5}
            alignItems={{ xs: 'flex-start', md: 'center' }}
            justifyContent="space-between"
        >
            <Box>
                <Typography variant="h3" sx={{ fontWeight: 900, color: '#ffffff', mb: 0.8, textAlign: 'start' }}>
                    לא בטוחים מה מתאים לעסק שלכם?
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.85)', lineHeight: 1.7, maxWidth: 640, textAlign: 'start' }}>
                    נשמח לעבור איתכם על תהליכי העבודה ולהמליץ על היכולות שיחסכו לכם הכי הרבה זמן.
                </Typography>
            </Box>
            <Button
                variant="contained"
                size="large"
                startIcon={<WhatsApp />}
                onClick={openGeneralContact}
                sx={{
                    borderRadius: '999px',
                    px: 4,
                    py: 1.4,
                    fontWeight: 900,
                    flexShrink: 0,
                    bgcolor: '#ffffff',
                    color: '#0c3f66',
                    '&:hover': { bgcolor: '#e8f6ff' }
                }}
            >
                דברו איתנו בוואטסאפ
            </Button>
        </Stack>
    </Box>
);

export default ContactBand;
